import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-graduated-2018',
  templateUrl: './graduated-2018.component.html',
  styleUrls: ['./graduated-2018.component.scss']
})
export class Graduated2018Component implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

}
